import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLayoutContext } from '../../../Context/Layout.context';
import { createFaq } from '../../../services/support/faq/supportFaq.service';
import useDocumentTitle from '../../../hooks/DocumentTitle/documentTitle';
import { FaqEditor } from './../FaqEditor/FaqEditor.component';

interface AddFaqProps {
  onClose: () => void;
  onChange: () => void;
}

export const AddFaq: React.FC<AddFaqProps> = ({ onClose, onChange }) => {
  const handleClose = () => {
    onClose();
  };
  const { t } = useTranslation();
  useDocumentTitle(t('support:header.addFaq'));
  const { openAlert } = useLayoutContext();

  const handleSave = (faqId: string, question: string, answer: string) => {
    createFaq(question, answer).then(
      () => {
        openAlert('success');
        onClose();
        onChange();
      },
      () => {
        openAlert('save_error');
      },
    );
  };

  return (
    <FaqEditor
      title={t('support:header.addFaq')}
      onCancel={handleClose}
      onSave={handleSave}
      onChange={onChange}
      question={''}
      answer={''}
      faqId={''}
    />
  );
};
